import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import {
  faCommentDots,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AddMessageButton,
  DisabledAddLinkButton,
  DeleteButton,
  DisabledAddImageButton,
} from '../Button/AddButton';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  putAPI_Update_Response,
  postAPI_Create_A_Message,
  putAPI_Delete_Response,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import ImageGallery from '../../gallery/index';
function Title({
  reloadBotResponse,
  code,
  type,
  msg,
  messages,
  example,
  isExample,
  index,
  isAdd,
  setIsAddMsgToFalse,
  numberOfMsg,
  /** for message-link type */
  link,
  caption,
  /** for message-image-carousel type */
  urls,
  captions,
  /** Globle property id from redux */
  propertyId,
  Title,
  SubTitle,
  AllButtons,
  SelectedButtons,
  isEditAble,
  imageUrl,
  locale,
  cardlink,
}) {
  const [isEditing, setIsEditing] = useState(true);
  const [isEdit, setIsEdit] = useState(isEditAble);
  const [messageInput, setMessageInput] = useState(msg);
  const [titleInput, setTitleInput] = useState(Title);
  const [subTitleInput, setSubTitleInput] = useState(SubTitle);
  const [linkUrlInput, setLinkUrlInput] = useState(cardlink);
  const [linkInput, setLinkInput] = useState(imageUrl);
  const [buttonList, setButtonList] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: code,
    Language: `${locale === 'en' ? 'en-US' : locale}`,
    Channel: 'WebsiteDirectLine',
    PropertyId: propertyId,
    Default: null,
    Overrides: {},
  });
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (link) => {
    setLinkInput(link.src);
  };

  const handleDelete = (code) => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Response}/${code}`,
      data: {
        GroupId: getGroupID(),
        PropertyId: propertyId,
        Language: `${locale === 'en' ? 'en-US' : locale}`,
        Channel: 'WebsiteDirectLine',
      },
    })
      .then((res) => {
        //console.log(res.data);
        toggle();
      })
      .finally(
        setTimeout(() => {
          reloadBotResponse();
        }, 1000)
      )
      .catch((err) => {
        console.log(err);
      });
  };
  const handleTextChange = (e) => {
    setTitleInput(e.target.value);
  };

  const handleSubTitleChange = (e) => {
    setSubTitleInput(e.target.value);
  };

  const handleUrlChange = (e) => {
    setLinkInput(e.target.value);
  };
  const handleLinkUrlChange = (e) => {
    setLinkUrlInput(e.target.value);
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const generateButtonGroup = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This response will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete(code)}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  useEffect(() => {
    const appAddonsArr = buttonList
      .filter((elem) => elem.checked === true)
      .map((elem) => ({
        text: elem.text,
        value: elem.value,
      }));

    setPostData({
      ...postData,
      Default: {
        Title: titleInput,
        SubTitle: subTitleInput,
        ImageUrl: linkInput,
        Buttons: appAddonsArr,
        Link: linkUrlInput,
      },
    });
  }, [titleInput, subTitleInput, linkInput, buttonList, linkUrlInput]);

  useEffect(() => {
    if (SelectedButtons !== undefined) {
      setButtonList(
        AllButtons.map((elem) => {
          elem.checked = false;
          SelectedButtons.forEach((r) => {
            if (r.value === elem.value) {
              elem.checked = true;
              elem.text = r.text;
            }
          });
          return elem;
        })
      );
    } else {
      setButtonList(
        AllButtons.map((p) => ({
          value: p.value,
          text: p.text,
          checked: false,
        }))
      );
    }
  }, []);

  const handleSave = async () => {
    try {
      return await AxiosAPI({
        method: 'put',
        url: putAPI_Update_Response,
        data: postData,
      })
        .then(() => {
          NotificationManager.success(
            '',
            'Bot Response Updated.',
            3000,
            null,
            null,
            'success'
          );
          setIsEdit(true);
        })
        .finally(
          setTimeout(() => {
            reloadBotResponse();
          }, 1000)
        );
    } catch (error) {
      console.error(error);
    }
  };

  const handleButtonChange = (e) => {
    console.log(e.target);
    const values = buttonList.map((elem) => {
      if (elem.value === e.target.name) {
        elem.text = e.target.value;
      }
      return {
        ...elem,
      };
    });
    setButtonList(values);
  };

  const handleRoleChange = (e) => {
    const values = buttonList.map((elem) => {
      if (elem.value === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setButtonList(values);
  };

  const Editing = () => {
    return (
      <Fragment>
        {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
        <CardTitle>
          <Row>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.Title" />
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12">
            <Input
              type="textarea"
              defaultValue={isEdit ? Title : `{ This is an example } ${Title}`}
              onChange={handleTextChange}
            />
          </Colxx>
        </Row>
        <CardTitle>
          <Row>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.SubTitle" />
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12">
            <Input
              type="textarea"
              defaultValue={
                isEdit ? SubTitle : `{ This is an example } ${SubTitle}`
              }
              onChange={handleSubTitleChange}
            />
          </Colxx>
        </Row>
        <Row className="mt-5">
          <Colxx xxs="2">Image Link</Colxx>
          <Colxx xxs="10">
            <Input
              type="text"
              value={linkInput}
              onChange={handleUrlChange}
            ></Input>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="2"></Colxx>
          <Colxx xxs="10">
            <div
              className="float-left"
              style={{ marginTop: ' 5px', marginBottom: '5px' }}
            >
              <Button
                color="primary"
                className="add-button"
                size="xs"
                onClick={togglegallery}
              >
                Browse Gallery
              </Button>
            </div>
          </Colxx>
        </Row>
        {(code === 'todays_deal' || code === 'camping_deals') && (
          <Row className="mt-5">
            <Colxx xxs="2">Link to deals page (optional)</Colxx>
            <Colxx xxs="10">
              <Input
                type="text"
                value={linkUrlInput}
                onChange={handleLinkUrlChange}
              ></Input>
            </Colxx>
          </Row>
        )}
        {ImageGalleryButton()}
        <Row className="mt-5">
          <Colxx xxs="2">Buttons</Colxx>
          <Colxx xxs="10">
            {buttonList.map((elem, index) => (
              <Row key={`buttonRow~${index}`}>
                <Colxx xxs="6" className="mt-1">
                  <CustomInput
                    key={`buttonChk~${index}`}
                    type="checkbox"
                    value={elem.value}
                    id={elem.value}
                    onChange={handleRoleChange}
                    checked={elem.checked}
                  >
                    {elem.text}
                  </CustomInput>
                </Colxx>
                <Colxx xxs="6" className="mt-1">
                  {elem.checked ? (
                    <Input
                      key={`buttontText~${index}`}
                      type="text"
                      value={elem.text}
                      name={elem.value}
                      onChange={handleButtonChange}
                    />
                  ) : null}
                </Colxx>
              </Row>
            ))}
          </Colxx>
        </Row>
        <Row className="mt-5">
          <Colxx xxs="6"></Colxx>
          <Colxx xxs="6">
            <div className="float-right">
              {isEdit ? (
                <Fragment>
                  <Button
                    color="secondary"
                    className="add-button"
                    size="xs"
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  <div
                    onClick={toggle}
                    className="ml-1"
                    style={{ display: 'inline-block' }}
                  >
                    <DeleteButton className="add-button" />
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  {' '}
                  <Button
                    color="secondary"
                    className="add-button"
                    size="xs"
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                </Fragment>
              )}
              <b> </b>
            </div>
          </Colxx>
        </Row>
        {generateButtonGroup()}
      </Fragment>
    );
  };

  return (
    <Card>
      <CardBody>{Editing()}</CardBody>
    </Card>
  );
}

// Message.propTypes = {
//   code: PropTypes.string.isRequired,
//   type: PropTypes.string.isRequired,
//   msg: PropTypes.string,
//   messages: PropTypes.array,
//   example: PropTypes.string,
//   index: PropTypes.number,
//   isAdd: PropTypes.bool,
//   setIsAddMsgToFalse: PropTypes.func,
//   link: PropTypes.string,
//   caption: PropTypes.string,
// };

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps)(Title));
